import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const andDescriptor = {
    input: TD.inlet(TD.Array(TD.Primitive<boolean>())),
    output: TD.outlet(TD.Primitive<boolean>()),
}

export class And implements NodeClassImpl<typeof andDescriptor, typeof And> {
    static descriptor = andDescriptor
    static uniqueName = "And"
    input!: Inlet<boolean[]>
    output!: Outlet<boolean>

    run() {
        if (this.input === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        for (const x of this.input) {
            if (!x) {
                this.output.emitIfChanged(false)
                return
            }
        }
        this.output.emitIfChanged(true)
    }
}
